import React from "react";

// Source
import * as HelperSrc from "../HelperSrc";
import * as ModelRoute from "../model/Route";
import ControllerBreadcrumb from "../controller/Breadcrumb";

let isRendered = false;

const viewBreadcrumb: React.FC = () => {
    // Variable
    const controllerBreadcrumb = new ControllerBreadcrumb(isRendered);

    // Method
    controllerBreadcrumb.initializeHook();

    // Render
    isRendered = true;

    if (controllerBreadcrumb.getStorageRoute) {
        return (
            <div className="view_breadcrumb">
                {(() => {
                    const html: JSX.Element[] = [];

                    const separator = " > ";

                    html.push(
                        <p
                            data-at_id="breadcrumb_home"
                            className="text"
                            onClick={() => {
                                controllerBreadcrumb.clickHome();
                            }}
                        >
                            <span className="link">Home</span>
                        </p>
                    );

                    const pathname = window.location.pathname.replace(`/${HelperSrc.LABEL}`, "");
                    const historyState = window.history.state as Record<string, unknown> | undefined;

                    if (historyState) {
                        for (const key in controllerBreadcrumb.getStorageRoute) {
                            const prevUrl = historyState.prevUrl as string;
                            const section = controllerBreadcrumb.getStorageRoute[key] as ModelRoute.IdataParameter;

                            if (key !== "main" && prevUrl && pathname === section.path) {
                                html.push(
                                    <div className="text">
                                        <p>{separator}</p>
                                        <p>
                                            {(() => {
                                                if (section.parent) {
                                                    html.push(
                                                        <div className="text">
                                                            <p>{separator}</p>
                                                            <p>
                                                                <span
                                                                    data-at_id="breadcrumb_parent"
                                                                    className="link"
                                                                    onClick={() => {
                                                                        if (section.onClick) {
                                                                            section.onClick();
                                                                        }
                                                                    }}
                                                                >
                                                                    {section.parent.replace("/", "")}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    );
                                                }
                                            })()}
                                            <span>{section.path.replace("/", "")}</span>
                                        </p>
                                    </div>
                                );
                            }
                        }
                    } else {
                        html.push(
                            <div className="text">
                                <p>{separator}</p>
                                <p>
                                    <span>{pathname.replace("/", "")}</span>
                                </p>
                            </div>
                        );
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <></>;
    }
};

export default viewBreadcrumb;
